import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';

@Component({
    selector: 'app-doctors',
    templateUrl: './doctors.component.html',
    styleUrls: ['./doctors.component.css'],
    standalone: false
})
export class DoctorsComponent implements OnInit {

  page = 1;
  pageSize = 10;
  list_length = 0;

  token: any;
  items: any[] = [];

  employeeName: any;

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private titleService: Title) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit() {
    this.getItems();
  }

  getItems(id?: any) {
    this.utility.loading = true;
    const sub = this.api.get('employees/role/doctor', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.list_length = this.items.length;

        localStorage.setItem('doctors', JSON.stringify(this.items));

        if (id)
          this.items = this.items.filter(i => i.user_id === id);
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  filterFunction(items: any[]) {
    if (this.employeeName == null)
      return items;
    else
      return items.filter(i => i.name.toLowerCase().indexOf(this.employeeName.toLowerCase()) >= 0 || i.phone.toString() === this.employeeName.toLowerCase());
  }

  saveDoctor(doctor: any) {
    localStorage.setItem('doctor', JSON.stringify(doctor));
  }
}
